import { Form, Input, message } from 'antd';
import { useState } from 'react';
import { AiOutlineArrowLeft, AiOutlineLock } from 'react-icons/ai';
import { Link, useHistory, useParams } from 'react-router-dom';

import { AuthLayout } from '../../../components/AuthLayout';
import { Button } from '../../../components/Common/Button';
import { Logo } from '../../../components/Common/Logo';
import { useMobileVersion } from '../../../hooks/useMobileVersion';
import { sendNewPassword } from '../../../operations/auth';
import * as authRules from '../../../rules/auth';
import { ContainerAuth, FormAuth, LinkAuth } from '../../../styles/common/auth';
import { ContentStyled, ParagraphStyled } from './styles';

type Params = {
  token: string;
};

export const NewPassword = () => {
  const history = useHistory();
  const { token } = useParams<Params>();
  const isMobileVersion = useMobileVersion();

  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async ({ password }: any) => {
    if (!token) {
      return message.error('Token não encontrado!');
    }

    try {
      setIsLoading(true);
      await sendNewPassword(password, token);
      setIsLoading(false);
      history.push('/login');
    } catch (error) {
      setIsLoading(false);
    }
  };

  if (isMobileVersion) {
    return (
      <ContainerAuth>
        <Logo height={35} />
        <ContentStyled>
          <h2>
            <Link to="/login">
              <AiOutlineArrowLeft />
            </Link>
            Criar nova senha
          </h2>
          <FormAuth onFinish={handleSubmit}>
            <Form.Item name="password" rules={authRules.password}>
              <Input.Password
                prefix={<AiOutlineLock />}
                placeholder="Nova senha"
                size="large"
              />
            </Form.Item>
            <Form.Item
              name="passwordConfirmation"
              rules={authRules.passwordConfirm}
            >
              <Input.Password
                prefix={<AiOutlineLock />}
                placeholder="Confirme a nova senha"
                size="large"
              />
            </Form.Item>
            <Button block htmlType="submit" loading={isLoading}>
              Enviar
            </Button>
          </FormAuth>
        </ContentStyled>
      </ContainerAuth>
    );
  }

  return (
    <AuthLayout>
      <ParagraphStyled>Digite sua nova senha</ParagraphStyled>
      <FormAuth onFinish={handleSubmit} style={{ maxWidth: 330 }}>
        <Form.Item name="password" rules={authRules.password}>
          <Input.Password
            prefix={<AiOutlineLock />}
            placeholder="Nova senha"
            size="large"
          />
        </Form.Item>
        <Form.Item
          name="passwordConfirmation"
          rules={authRules.passwordConfirm}
        >
          <Input.Password
            prefix={<AiOutlineLock />}
            placeholder="Confirme a nova senha"
            size="large"
          />
        </Form.Item>
        <Button block htmlType="submit" loading={isLoading}>
          Enviar
        </Button>
      </FormAuth>
      <LinkAuth style={{ marginTop: '10px' }} to="/login">
        Fazer login
      </LinkAuth>
    </AuthLayout>
  );
};
